import AttributeValidator from '../AttributeValidator';
import ErrorMessageFactory from './ErrorMessageFactory';

/**
 * Convert an Attribute Validator result into an Attribute Resolver result.
 * The result will be 'resolved' when the validation deemed the selection valid and complete.
 * @param {object} validationResult The validation result to convert.
 * @returns {object} The result of resolving the attributes, as defined by the validation result.
 */
function convert(validationResult) {
  const isFullyResolved = validationResult.isValid && validationResult.isComplete;

  const resolutionResult = { resolved: isFullyResolved };
  if (isFullyResolved) {
    resolutionResult.resolvedAttributes = validationResult.finalSelections;
  } else {
    resolutionResult.errorMessages = ErrorMessageFactory.create(validationResult);
  }

  return resolutionResult;
}

/**
 * Responsible for resolving an attribute selection against a rule set to determine the
 * fully set of Resolved Attributes (previous known as finalSelections).
 */
export default class AttributeResolver {
  /**
   * Resolve the attribute selection against the rule set, yielding the resolved attributes
   * for a resolvable selection.
   * @param {object} ruleSet The v1 rule set to resolve the attributes against.
   * @param {object} attributeSelection The selection of attribute values to resolve.
   * @returns {object} An object describing how the attribute selection resolved.
   */
  static resolve(ruleSet, attributeSelection) {
    const validationResult = AttributeValidator.validate(ruleSet, attributeSelection);

    const resolutionResult = convert(validationResult);

    return resolutionResult;
  }
}
